//lib
//redux
import { useDispatch, useSelector } from "react-redux";
import {
  setFilterData,
  setSavedProduct,
} from "../../../redux/reducer/product.reducer";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Container from "../../../components/element/container";
import Image from "../../../components/element/image";
import { useTranslation } from "react-i18next";
import useWindowDimension from "../../../components/hook/use.window.dimension";

export default function HomeCategory() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isDesktop } = useWindowDimension();
  const { categoryList, filterData } = useSelector((state) => state.product);

  const handleSelectCategory = (category) => {
    const selectedCategory = category || "all";
    const nextCategory = selectedCategory === (filterData.category || "all")
      ? "all" : selectedCategory;

    dispatch(setSavedProduct([]));
    dispatch(
      setFilterData(
        isDesktop
          ? { ...filterData, category: nextCategory }
          : {
              // There is no filter sidebar to apply on a phone, so picking a
              // category asks for that category's results straight away.
              ...filterData,
              category: nextCategory,
              [nextCategory]: {
                ...(filterData[nextCategory] || {}),
                start: 0,
                refresh_key: Date.now(),
              },
            },
      ),
    );
  };

  return (
    <Container className="home-category">
      <Row className="_row category-list">
        {categoryList.map((category, categoryIndex) => {
          return (
            ((isDesktop && category.label === "All") ||
              category.label !== "All") && (
              <Col
                className={`_col category-item ${
                  (filterData.category || "all") === (category.value || "all")
                    ? "active"
                    : ""
                } pointer`}
                key={categoryIndex}
                onClick={() => handleSelectCategory(category.value)}
              >
                <Col className="_col active-overlay">
                  <Image src={category.image} className="_img" />
                </Col>

                <h4 className="_label category-title">
                  {t(category.label)}&nbsp;
                </h4>
              </Col>
            )
          );
        })}
      </Row>
    </Container>
  );
}
